<template>
  <div class="mine-page page p-0!">
    <div class="p-20px pb-0! pt-42px flex justify-between items-center">
      <!-- <FixedHeader :showSetting="true" /> -->
      <div class="flex bg-#FFFFFF header-round rounded-10 p-4px pl-10px pr-5px items-center justify-center"
        @click="handleAdd">
        <img src="@/assets/images/home/crystal.webp" class="w-14px h-14px mr-5px mt-1px"></img>
        <div class="text-14px font-500 color-#fff">
          {{ msgCost }}
        </div>
        <img src="@/assets/images/home/add.svg" class="w-20px h-20px ml-5px"></img>
      </div>
      <div class="flex items-center justify-center">
        <div class="ml-15px flex items-center justify-center" @click.stop.prevent="handleDiscord"
          @touchend.stop.prevent="handleDiscord">
          <img src="@/assets/images/home/discord.svg" class="w-30px h-30px"></img>
        </div>
        <div class="ml-15px flex items-center justify-center" @click.stop.prevent="handleSetting"
          @touchend.stop.prevent="handleSetting">
          <img src="@/assets/images/mine/settings.svg" class="w-24px h-24px"></img>
        </div>
      </div>
    </div>
    <!-- 顶部用户信息 -->
    <div class="mine-header pr-0!" :class="isLoggedIn ? 'p-20px' : 'p-20px pb-0! pr-0!'">
      <div class="profile">
        <div class="avatar">
          <div class="avatar-inner">
            <img :src="userInfo.avatar" alt="" class="w-60px h-60px">
          </div>
        </div>
        <div class="profile-info">
          <div class="nickname text-ellipsis overflow-hidden max-w-120px flex items-center">
            <button class="btn-sign" @click.stop.prevent="handleSignUp" @touchend.stop.prevent="handleSignUp"
              v-if="!userInfo.email">{{ t('mine.bindEmail') }}</button>

            <div class="mr-4px text-ellipsis overflow-hidden max-w-100px" v-else>
              {{ userInfo.nickname || '--' }}
            </div>
            <!-- <div class="w-16px h-14px flex items-center" @click="handleShowPopup" v-if="[3].includes(userInfo?.role)">
              <img src="@/assets/images/mine/VIP.webp" alt="" class="w-full h-full"
                v-if="![3].includes(userInfo?.role)">
              <img src="@/assets/images/mine/VIP_to.webp" alt="" class="w-full h-full" v-else>
            </div> -->
            <!-- <div class="w-16px h-14px flex items-center" @click="handleShowPopup" v-if="[4].includes(userInfo?.role)">
              <img src="@/assets/images/mine/no_svip.webp" alt="" class="w-full h-full"
                v-if="![4, 5].includes(userInfo?.role)">
              <img src="@/assets/images/mine/svip.webp" alt="" class="w-full h-full" v-else>
            </div> -->
          </div>
          <div class="uid" @click="copyUserId">ID:{{ userInfo.userId || '--' }}</div>
        </div>
      </div>
      <!-- <div class="ml-15px" @click.stop.prevent="goCheckInCenter" @touchend.stop.prevent="goCheckInCenter">
        <img src="@/assets/images/mine/check_in.svg" class="w-full h-full "></img>
      </div> -->
    </div>

    <vipBanner />

    <!-- </div> -->
    <!-- 设置标题 - 独立固定 -->
    <div
      class="tabbar-title gap-10px flex text-14px font-900 sticky top-0px z-10 h-50px bg-#01031B items-center px-20px">
      <div @click="tabbarClick(0)" :class="{ 'active': activeTabIndex === 0 }">
        {{ t('message.like') }}
      </div>
      <div @click="tabbarClick(1)" :class="{ 'active': activeTabIndex === 1 }">
        {{ t('mine.backpackTitle') }}
      </div>
    </div>

    <!-- 🚀 轮播内容区域 -->
    <div class="mine-tabs-container">
      <van-swipe ref="swipeRef" :loop="false" :show-indicators="false" :touchable="true" @change="handleSwipeChange"
        class="mine-swipe" :style="{ height: swipeHeight }">
        <!-- Tab 0: Like -->
        <van-swipe-item class="mine-swipe-item" :ref="setLikeRef">
          <like />
        </van-swipe-item>

        <!-- Tab 1: Backpack -->
        <van-swipe-item class="mine-swipe-item" :ref="setBackpackRef">
          <backpack @open-preview="handleOpenPreview" />
        </van-swipe-item>
      </van-swipe>
    </div>



    <popupSlide v-model:showPopup="showPopup" />
    <AppOccupySpace height="80px"></AppOccupySpace>

  </div>
  <!-- 全屏图片预览（由父组件控制） -->
  <FullscreenImagePreview v-model:show="showImagePreview" :isShowbackDrop="false" :images="previewImages"
    :infoItem="infoItem" :start-position="previewStartPosition" @close="handleCloseImagePreview"
    :isShowSetAsBackdrop="isShowSetAsBackdrop" :isShowGotoChat="true" @goToChat="handleGoToChat" />
</template>

<script setup lang="ts" name="minePage">
import theme from '@/styles/theme'
import vipBanner from './com/vipBanner.vue'
import { AppOccupySpace, FixedHeader } from '@/components/layout'
import { FullscreenImagePreview } from '@/components/feedback'
import like from './com/like.vue'
import backpack from './com/backpack.vue'
import { useRouter, useRoute } from 'vue-router'
import { useUserStore } from '@/stores/user'
import { computed, onMounted, ref, nextTick, watch } from 'vue'
import { showToast, showLoadingToast, closeToast } from '@/utils/toast'
import popupSlide from '../home/com/FirstChargePopUp.vue'
import { useCheckInCenterStore } from '@/stores/checkInCenter'
import { useMineStore } from '@/stores/mine'
import { MessageAPI } from '@/services/message'
import { detailDB } from '@/utils/detailDB'
import { useI18n } from 'vue-i18n'
const router = useRouter()
const { t } = useI18n()
const userStore = useUserStore()
const isLoggedIn = computed(() => userStore.isLoggedIn)
const userInfo = computed(() => userStore.userInfo)
const showPopup = ref(false)
const activeTabIndex = ref(0)
const mineStore = useMineStore()
const msgCost = computed(() => userStore.msgCost)
// 🚀 轮播组件引用
const swipeRef = ref()
// 🚀 每个 tab 的引用和高度
const likeRef = ref<HTMLElement>()
const backpackRef = ref<HTMLElement>()
const swipeHeight = ref('auto')
// 全屏预览状态
const showImagePreview = ref(false)
const previewImages = ref<string[]>([])
const previewStartPosition = ref(0)
const infoItem = ref<any>()
const itemData = ref<any>()
const isShowSetAsBackdrop = ref(false)
const route = useRoute()
const userData = computed(() => JSON.parse(localStorage.getItem('ai-chat-user') || '{}'))
// 设置 ref
const setLikeRef = (el: any) => {
  if (el) {
    likeRef.value = el.$el || el
  }
}

const setBackpackRef = (el: any) => {
  if (el) {
    backpackRef.value = el.$el || el
  }
}

// 🚀 更新轮播高度
const updateSwipeHeight = () => {
  nextTick(() => {
    const currentRef = activeTabIndex.value === 0 ? likeRef.value : backpackRef.value
    if (currentRef) {
      const height = currentRef.scrollHeight
      swipeHeight.value = `${height}px`
    }
  })
}


const handleAdd = () => {
  router.push({ name: 'Store' })
}

/**
 * 处理discord
 */
const handleDiscord = () => {
  showLoadingToast(t('dialog.processing'), { duration: 2000 })
  window.location.href = userData.value.contactUs || 'https://discord.gg/WNTyxU5mHk'
  setTimeout(() => {
    closeToast()
  }, 2000)
}

/**
 * 处理设置
 */
const handleSetting = () => {
  router.push({ name: 'Setting' })
}

// 🚀 监听 activeTabIndex 变化，更新高度 (添加防抖优化)
let heightUpdateTimer: ReturnType<typeof setTimeout> | null = null
watch(activeTabIndex, () => {
  // 防抖优化: 避免频繁计算高度
  if (heightUpdateTimer) clearTimeout(heightUpdateTimer)
  heightUpdateTimer = setTimeout(() => {
    updateSwipeHeight()
  }, 100)
}, { immediate: true })

/**
 * 切换tabbar
 * @param index 
 */
const tabbarClick = (index: number) => {
  activeTabIndex.value = index
  if (swipeRef.value) {
    swipeRef.value.swipeTo(index)
  }
}

/**
 * 🚀 轮播切换事件（滑动触发）
 */
const handleSwipeChange = (index: number) => {
  activeTabIndex.value = index
  updateSwipeHeight()
}
/**
 * 跳转到签到中心
 */
const goCheckInCenter = () => {
  router.push({ name: 'CheckInCenter' })
}
/**
 * 显示充值弹窗
 */
const handleShowPopup = () => {
  showPopup.value = true
}
/**
 * 跳转到登录页面
 */
const handleSignUp = () => {
  router.push(
    { path: '/login', query: { isRegisterUrl: 'true', isSignInUrl: 'false', isLoginUrl: 'true' } }
  )
}

const copyUserId = async () => {
  try {
    // 优先使用现代 Clipboard API
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(userInfo.value.userId)
      showToast(t('account.copiedToClipboard'), { type: 'success' })
    } else {
      // 降级到传统方法
      const success = fallbackCopyText(userInfo.value.userId)
      if (success) {
        showToast(t('account.copiedToClipboard'), { type: 'success' })
      } else {
        showToast(t('account.copyFailed'), { type: 'error' })
      }
    }
  } catch (err) {
    // Clipboard API 失败，使用降级方案
    console.error('Clipboard API failed:', err)
    const success = fallbackCopyText(userInfo.value.userId)
    if (success) {
      showToast(t('account.copiedToClipboard'), { type: 'success' })
    } else {
      showToast(t('account.copyFailed'), { type: 'error' })
    }
  }
}

const fallbackCopyText = (text: string) => {
  // 创建临时 textarea
  const textArea = document.createElement('textarea');
  textArea.value = text;

  // 避免滚动到可视区域
  textArea.style.position = 'fixed';
  textArea.style.top = '-9999px';
  textArea.style.left = '-9999px';
  textArea.style.opacity = '0';

  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    // 执行复制命令
    const successful = document.execCommand('copy');
    document.body.removeChild(textArea);

    if (successful) {
      console.log('复制成功（传统方法）');
      return true;
    } else {
      console.error('复制失败');
      return false;
    }
  } catch (err) {
    console.error('复制错误:', err);
    document.body.removeChild(textArea);
    return false;
  }
}

// 打开全屏预览（来自子组件）
const handleOpenPreview = (item: any) => {
  previewImages.value = [item.original]
  showImagePreview.value = true
  itemData.value = item
  infoItem.value = item
}

// 关闭全屏预览
const handleCloseImagePreview = () => {
  showImagePreview.value = false
  previewImages.value = []
  previewStartPosition.value = 0
}

// 前往聊天
const handleGoToChat = async () => {
  try {
    // 判断是否存在
    if (!itemData.value) return
    // 获取ID
    const id = itemData.value.roleId || itemData.value.id
    // 显示加载中
    showLoadingToast('loading')
    // 获取详情数据
    const res = await MessageAPI.getRoleDetail({ id })
    // 保存详情数据
    await detailDB.save(id, res.data)
    // 预传数据
    const preData = {
      id: id,
      name: res.data.name,
      avatar: res.data.avatar,
      background: res.data.background,
    }
    // 跳转聊天
    closeToast()
    router.push({ path: '/chat', query: { isMessage: 'true', preData: JSON.stringify(preData), route: route.path } }).catch(() => { })

  } catch (error) {
    console.error('跳转失败:', error)
    router.push({ path: '/chat' })
  }
}





onMounted(async () => {
  // 获取存储的 token
  const token = userStore.getStoredToken()
  // 如果有 token，尝试获取用户信息
  if (token) {
    try {
      await userStore.getIsLoggedIn()
    } catch (error) {
      console.error('Failed to get user info:', error)
      // 如果获取失败，token 可能已过期，会由 HTTP 拦截器处理重定向
    }
  }

  // 🚀 优化: 签到数据异步加载,不阻塞页面渲染
  Promise.all([
    useCheckInCenterStore().getCheckInCenterList(),
    useCheckInCenterStore().getSignInList()
  ]).catch(err => console.error('签到数据加载失败:', err))

  // 🚀 优化: 只加载当前激活的tab数据,另一个tab延迟加载
  if (activeTabIndex.value === 0) {
    await mineStore.refreshLikeList()
    // 延迟加载backpack数据
    setTimeout(() => mineStore.refreshBackpackList(), 1000)
  } else {
    await mineStore.refreshBackpackList()
    // 延迟加载like数据
    setTimeout(() => mineStore.refreshLikeList(), 1000)
  }

  // 🚀 初始化轮播位置和高度
  nextTick(() => {
    if (swipeRef.value) {
      swipeRef.value.swipeTo(activeTabIndex.value, { immediate: true })
    }
    // 延迟更新高度，确保 DOM 已渲染
    setTimeout(() => {
      updateSwipeHeight()
    }, 100)
  })
})
</script>

<style scoped lang="scss">
.header-round {
  background: rgba(255, 255, 255, 0.1);
}

.mine-page {
  padding: 20px;
  min-height: 100vh;
  background: v-bind('theme.colors.background');

  .mine-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 14px;

    .profile {
      display: flex;
      align-items: center;

      .avatar {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        padding: 2px;
        // background: linear-gradient(180deg, #5A68FF 0%, #95A5FF 100%);
        display: flex;
        align-items: center;
        justify-content: center;

        .avatar-inner {
          flex-shrink: 0;
          width: 60px;
          height: 60px;
          border-radius: 50%;
          background: #2b2e50;
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }

      .profile-info {
        margin-left: 10px;

        .nickname {
          color: #fff;
          font-weight: 900;
          font-size: 16px;
          line-height: 1.2;
        }

        .uid {
          color: v-bind('theme.colors.textPrimary');
          font-size: 10px;
          margin-top: 4px;
        }
      }
    }

    .btn-sign {
      width: 72px;
      height: 28px;
      border: none;
      border-radius: 6px;
      font-size: 16px;
      color: #333333;
      font-weight: 800;
      background: #FFFFFF;
      font-weight: 500;
      font-size: 12px;
      color: #333333;
    }
  }

  .reward-banner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    // padding: 14px;
    border-radius: 14px;
    // background: linear-gradient(90deg, #A88BFF 0%, #6A8BFF 100%);
    margin-bottom: 18px;

    gap: 10px;

    .gems {
      // width: 100px;
      width: 33%;
      padding: 10px;
      padding-right: 0px;
      border-radius: 10px;
      background: linear-gradient(135deg, rgba(152, 103, 250, 0.3) 0%, rgba(49, 150, 242, 0.3) 100%);
      color: rgba(255, 255, 255, 0.3);

    }

    .like {
      // width: 100px;
      width: 33%;

      padding: 10px;
      border-radius: 10px;
      background: linear-gradient(135deg, rgba(217, 105, 208, 0.3) 0%, rgba(44, 79, 204, 0.3) 100%);
      color: rgba(255, 255, 255, 0.3);
      padding-right: 10px;
    }

    .backpack {
      width: 33%;

      // width: 100px;

      padding: 10px;

      color: rgba(255, 255, 255, 0.3);
      background: linear-gradient(135deg, rgba(114, 187, 240, 0.3) 0%, rgba(152, 155, 250, 0.3) 100%);
      border-radius: 10px;
    }
  }

  .section-title {
    font-weight: 900;
    font-size: 14px;
    color: #FFFFFF;
    margin-bottom: 8px;
    position: relative;

  }

  .settings-list {
    margin-top: 12px;

    .setting-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 40px;
      padding: 0 14px;
      border-radius: 12px;
      background: v-bind('theme.colors.backgroundSecondary');
      color: #fff;
      margin-bottom: 10px;

      .left {
        display: flex;
        align-items: center;

        .icon {
          margin-right: 10px;
          width: 20px;
          text-align: center;
        }

        .text {
          font-weight: 500;
          font-size: 14px;
          color: #FFFFFF;
        }

        .dot {
          position: absolute;
          top: 0px;
          right: -6px;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: #ff4d8d;
          // margin-left: 6px;
        }
      }

      .arrow {
        color: v-bind('theme.colors.textPrimary');
        font-size: 18px;
      }
    }
  }

  // Tab 标题栏（吸顶）
  .tabbar-title {
    color: v-bind('theme.colors.textPrimary');
    position: sticky;
    top: 0;
    z-index: 10;
    background-color: v-bind('theme.colors.background');

    .active {
      color: #fff;
      position: relative;

      &::after {
        content: '';
        display: block;
        width: 10px;
        height: 2px;
        // background: #FFFFFF;
        background: #fff;
        border-radius: 1px;
        position: absolute;
        bottom: -3px;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }

  // 🚀 轮播容器
  .mine-tabs-container {
    padding: 0 20px;
    padding-bottom: 20px;
    box-sizing: border-box;
  }

  .mine-swipe {
    // 🚀 使用动态高度，添加平滑过渡
    overflow: hidden;
    transition: height 0.3s ease;

    :deep(.van-swipe__track) {
      // 关键：让轨道高度自适应
      height: 100% !important;
      display: flex;
      // 🔥 阻止 flex 拉伸所有子元素到相同高度
      align-items: flex-start !important;
      transform: translateZ(0);
      will-change: transform;
      backface-visibility: hidden;
    }
  }

  .mine-swipe-item {
    // 每个轮播项独立高度，由内容决定
    height: auto !important;
    flex-shrink: 0;
    width: 100%;
    overflow: visible;
  }
}
</style>
